// Package imports:
import React from 'react';
// Component imports:
import Modal from '../../ui-elements/Modal/Modal';

interface IProps {
    show: boolean,
    close(): void
};

const Fyrirvari: React.FC<IProps> = ({show, close, children}) =>  (
    <Modal
        show={show}
        onHide={close}
        hasCloseButton
        header='Fyrirvari'
        body={children}
    />
);

export default Fyrirvari;